import { Button } from "antd";
import { useNavigate } from "react-router";
import { MessagesChannelSwitcher } from "./MessagesChannelSwitcher";

/**
 * R2-24 — THE CHANNEL IS LOCKED, NOT BROKEN.
 *
 * The PO (2026-10-03), standing on the LinkedIn surface: *"first i see an 'ERROR', then i see a
 * FULL RELOAD.. and then i see 'The LinkedIn engine is not answering…' TERRIBLE EXPERIENCE. just
 * lock it up for now, same also for whatsapp. coming soon or something. BUT YEAH THIS CANT HAPPEN.
 * this must load in milliseconds."*
 *
 * The chip in `MessagesChannelSwitcher` already knew how to say "coming soon" — `DomainSwitcher`
 * renders a non-live option as a dashed statement that cannot be clicked, which is the treatment
 * the capital surface gives Procurement and Recruitment. What was missing was the ROUTE. Marking
 * the channel non-live stops the switcher navigating, but a bookmarked URL, a back button, or the
 * integrations page's own link could still mount the board — and mounting the board is what opened
 * the socket, painted the failure, and reloaded the app on top of it.
 *
 * So the page says exactly what the chip says. Nothing here calls an engine, waits on a socket or
 * retries: the surface is a statement and a way back, which is the whole point — a locked door is
 * fast, and it never pretends to be a slow one.
 */
export function ChannelComingSoon({ channel }: { channel: "LinkedIn" | "WhatsApp" }) {
  const navigate = useNavigate();

  return (
    <div className="flex h-full min-h-0 flex-col">
      <MessagesChannelSwitcher className="px-4 py-3" />
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="max-w-md rounded-lg border border-dashed bg-card p-6 text-center">
          <h2 className="text-base font-semibold text-foreground">{channel} — coming soon</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            The {channel} messages board is not switched on yet. There is nothing to read here and
            nothing to sign in to — your email is not affected.
          </p>
          <Button className="mt-4" onClick={() => navigate("/messages")}>
            Go to Email
          </Button>
        </div>
      </div>
    </div>
  );
}
